module.exports = __webpack_public_path__ + "img/mind-logo.8e713538.png";